function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#767E9D",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 12.975v-6h13.999l-.002 6H2zm0-8h2v-2H2v2zm4 0h2v-2H6v2zm4 0h6v-2h-6v2zm8 8v-10c0-1.102-.897-2-2-2H2c-1.104 0-2 .898-2 2v10a2 2 0 0 0 2 2h14c1.103 0 2-.896 2-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 4.975a1 1 0 0 0-1 1v10H5a1 1 0 0 0 0 2h14c1.103 0 2-.896 2-2v-10a1 1 0 0 0-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 8.975v10H8a1 1 0 0 0 0 2h14c1.103 0 2-.896 2-2v-10a1 1 0 0 0-2 0z"
}));

var SvgTabs = function SvgTabs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTabs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Tabs.cf379362.svg";
export { ForwardRef as ReactComponent };